import React, { Component } from 'react';
import {MainLayout} from 'components/layouts';
import {OrderList} from 'components/fair/fair-order';
import {Link} from 'react-router-dom';

export default class FairOrders extends Component {

  render() {
    return (
      <MainLayout>
        <div>
          <div className='mb15'>
            <Link className='btn-back' to={`/fair/${this.props.match.params.id}`}><i className='fa fa-chevron-left' />Quay về trang chi tiết hội chợ</Link>
          </div>
          <div className='wrap-heading'>
            <h1>Danh sách đơn hàng chưa xử lý của hội chợ</h1>
            <div className='list-actions'>
              <Link to={`/fair/${this.props.match.params.id}/orders/canceled`} className='dark'>Đơn hàng đã hủy</Link>
              <Link to={`/fair/${this.props.match.params.id}/orders/closed`}>Đơn hàng đã chuyển</Link>
            </div>
          </div>
          <OrderList match={this.props.match} />
        </div>
      </MainLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./pages/fair/fair-orders/FairOrders.jsx